class TwistyRouteMarker{

    iconDefault(){

        return {
            url: window.host + "/uploads/static/routes/twisty_route.png",
            scaledSize: new google.maps.Size(6, 6),
            borderColor: "#137333",
        };

    }

    createMarker(route){

        return new google.maps.Marker({
            position: new google.maps.LatLng(route.position.lat, route.position.lng),
            icon: this.iconDefault(route),
        });

    }

}

export default TwistyRouteMarker;